module.exports = __webpack_public_path__ + "img/BI_7.cb7ad391.png";